import { Injectable } from "@angular/core";
import { SampleTasks } from "../models/sampleTasks.model";
import { GridService } from "../shared/grid/grid.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class SampleTaskService extends GridService<SampleTasks> {
    constructor(http: HttpClient) {
        super('SampleTask', http);
    }

    getSampleTasks(sampleId: string) {
        return this.http.get<SampleTasks[]>(this.getApiUrl(`${this.controllerName}/GetSampleTasks?sampleId=` + sampleId));
    }
}